import type { Slot } from "@medplum/fhirtypes";
import { SLOT_COLLECTION_NAME } from "../../fhir";
import { createSubscriptionHook } from "./create-subscription-hook";

/**
 * Hook that subscribes to Slot resource changes via WebSocket and updates the
 * unified `slot` TanStack DB collection in real-time.
 *
 * Must be used inside FhirDataStoreProvider.
 */
export const useSlotSubscription = createSubscriptionHook<Slot>("Slot", SLOT_COLLECTION_NAME);
